import React, { useContext, useEffect, useState } from 'react'
import './Login.css'
import { useHistory } from 'react-router-dom'
import CheckBox from '@/product/components/atoms/CheckBox'
import { Link } from 'react-router-dom'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import { LOGO, SITE_NAME } from '@/utils/UI'
import { mapData, handleRedirectInternal } from '@/product/common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import AuthContext from '@/product/context/auth/authContext'
import AlertContext from '@/product/context/alert/alertContext'
import Loaders from '@/product/components/molecules/Loaders'
import { Divider } from '@mui/material'
import { encrypt, decrypt } from '@/product/common/cryptos'
import { Buffer } from 'buffer'
import TwofactorContext from '@/product/context/twoFactor/twofactorContext'
import CustomDialog from '@/product/components/organisms/Dialog'

const Login = (props) => {
    const history = useHistory()
    const authContext = useContext(AuthContext)
    const alertContext = useContext(AlertContext)
    const [isLoading, setIsLoading] = useState(true)
    const twofactorContext = useContext(TwofactorContext)

    const { setAlert } = alertContext

    const {
        login,
        responseStatus,
        clearResponse,
        isAuthenticated,
        loadUser,
        get2faDetails,
        twoFactor_details,
    } = authContext

    const {
        get2faRequest,
        request_data,
        verify2fa,
        revoke2fa,
        responseStatus: responseStatusFactor,
        clearResponse: clearResponseFactor,
    } = twofactorContext

    const [showOtp, setshowOtp] = useState(false)
    const [updated, setUpdated] = useState(false)
    const [twofaMessage, setTwofaMessage] = useState('')

    useEffect(() => {
        setIsLoading(false)
        if (isAuthenticated && localStorage.token) {
            handleRedirectInternal(history, 'dashboard')
        }
    }, [isAuthenticated])

    const validationArray = Yup.object({
        email: Yup.string().email('Invalid email format').required('Required!'),
        password: Yup.string()
            .min(8, 'Minimum 8 characters')
            .required('Required!'),
        otp: showOtp
            ? Yup.string()
                  .min(6, 'Enter the complete OTP')
                  .required('Required!')
            : Yup.string(),
    })

    const formik = useFormik({
        initialValues: {
            email: '',
            password: '',
            remember_me: true,
            otp: '',
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            if (values.remember_me) {
                let emailValue = values.email
                let passwordValue = values.password
                localStorage.setItem(
                    'remember_email',
                    Buffer.from(emailValue.toString(), 'binary').toString(
                        'base64'
                    )
                )
                localStorage.setItem(
                    'remember_password',
                    Buffer.from(passwordValue.toString(), 'binary').toString(
                        'base64'
                    )
                )
            } else {
                localStorage.removeItem('remember_email')
                localStorage.removeItem('remember_password')
            }

            setIsLoading(true)
            setUpdated(true)
            login(values)
        },
    })

    const loginInfo = [
        {
            label: 'Email address',
            name: 'email',
            type: 'email',
            placeholder: 'Enter your email address',
            class: 'col-12',
            // autoFocus: true,
            formik: formik,
            enableAutofillCheck: props?.enableAutofillCheck,
        },
        {
            label: 'Password',
            name: 'password',
            type: 'password',
            placeholder: 'Enter your password',
            class: 'col-12',
            formik: formik,
            enableAutofillCheck: props?.enableAutofillCheck,
        },
        {
            label: 'Remember Me',
            name: 'remember_me',
            type: 'checkbox',
            placeholder: 'Enter your password',
            class: 'fpCnt col-12 d-flex justify-content-between align-items-center mb-2',
            formik: formik,
        },
    ]

    useEffect(() => {
        if (responseStatus) {
            if (responseStatus.from === 'login') {
                if (responseStatus.status === 'success') {
                    if (responseStatus.type == 3) {
                        if (localStorage.redirect_url) {
                            console.log(
                                localStorage.redirect_url,
                                'reffttt',
                                localStorage.redirect_url.substring(1)
                            )
                            handleRedirectInternal(
                                history,
                                localStorage.redirect_url.substring(1)
                            )
                            localStorage.removeItem('redirect_url')
                        } else {
                            handleRedirectInternal(history, 'dashboard')
                        }
                    } else if (
                        responseStatus.type === 21 ||
                        responseStatus.type === 22 ||
                        responseStatus.type === 23
                    ) {
                        get2faDetails({
                            email: formik.values.email,
                        })
                    }
                } else {
                    if (responseStatus.message !== 'Logged in successfully') {
                        setAlert(responseStatus.message, responseStatus.status)
                    }
                }
            }
            clearResponse()
            setIsLoading(false)
        }
    }, [responseStatus])

    useEffect(() => {
        if (
            responseStatusFactor &&
            responseStatusFactor.from === 'verifyLogin'
        ) {
            setAlert(responseStatusFactor.message, responseStatusFactor.status)
            if (responseStatusFactor.status !== 'error') {
                formik.values.otp = ''
                handleRedirectInternal(history, 'dashboard')
            }
            setIsLoading(false)
        }
        clearResponseFactor()
    }, [responseStatusFactor])

    useEffect(() => {
        if (twoFactor_details && twoFactor_details.record.length && updated) {
            console.log(twoFactor_details.record[0], 'two factor record')
            let userData = twoFactor_details.record[0]
            setTwofaMessage(userData.twofa_message)
            if (userData['2fa_enable']) {
                setshowOtp(true)
                setIsLoading(false)
            } else {
                handleRedirectInternal(history, 'dashboard')
            }
            clearResponse()
        }
    }, [twoFactor_details])

    useEffect(() => {
        let localEmail = localStorage.getItem('remember_email')
        let localPassword = localStorage.getItem('remember_password')

        if (localEmail) {
            formik.setFieldValue(
                'email',
                Buffer.from(localEmail, 'base64').toString('binary')
            )
        }

        if (localPassword) {
            formik.setFieldValue(
                'password',
                Buffer.from(localPassword, 'base64').toString('binary')
            )
        }
    }, [
        localStorage.getItem('remember_email'),
        localStorage.getItem('remember_password'),
    ])

    const otpData = [
        {
            label: 'Enter OTP',
            name: 'otp',
            type: 'otpInput',
            placeholder: 'Enter your otp',
            class: 'col-12',
            formik: formik,
        },
    ]

    return (
        <div className="login">
            {isLoading ? (
                <Loaders name="banner" isLoading={isLoading} />
            ) : (
                <>
                    <div className="loginCnt">
                        <form onSubmit={formik.handleSubmit}>
                            <div className="row">
                                <div className="loginLogo">
                                    <img src={LOGO} alt={SITE_NAME} />
                                </div>
                                <div className="col-12 loginTitle">
                                    <h2>Welcome to {SITE_NAME}</h2>
                                </div>

                                <div className="w-100">
                                    {mapData(loginInfo)}
                                </div>
                                <div className="col-12">
                                    <PrimaryButton
                                        id="login_submit"
                                        label="Login"
                                        type="submit"
                                        btnSize="large"
                                    />
                                </div>
                            </div>
                        </form>
                        <div className="loginMiscAction d-flex justify-content-center mt-3 align-items-center">
                            <Link to="/forgot_password">Forgot password?</Link>
                        </div>
                    </div>
                    <CustomDialog
                        title={''}
                        open={showOtp}
                        // open={true}
                        className="doubleAuthModal logInVerificationModal"
                        disableBackdropClick
                    >
                        <span
                            className="material-icons"
                            onClick={() => {
                                setshowOtp(false)
                                formik.setFieldValue('otp', '')
                            }}
                        >
                            clear
                        </span>
                        <div
                            className="d-flex flex-column align-items-center"
                            style={{ marginBottom: '24px', gap: '6px' }}
                        >
                            <span className="material-icons-outlined cstmLogInLock">
                                lock_person
                            </span>
                            <h5 className="m-0 cstmLogInTitle">
                                Please enter the otp to verify
                            </h5>
                        </div>
                        <div
                            className="d-flex flex-column align-items-start"
                            style={{ gap: '8px' }}
                        >
                            <span className="m-0 twoFaMsgTxtCnt">
                                {twofaMessage ? twofaMessage : null}
                            </span>

                            <span>
                                You will be required to enter a One-Time
                                Password sent for every login.
                            </span>
                            <div
                                className="actionWrapper"
                                style={{ marginTop: '0px', width: '100%' }}
                            >
                                <form
                                    onSubmit={formik.handleSubmit}
                                    autoComplete="nofill"
                                >
                                    <div>
                                        <span
                                            style={{
                                                color: 'black',
                                                fontWeight: '500',
                                                fontSize: '14px',
                                            }}
                                        >
                                            One-Time Password
                                        </span>
                                        <div className="row">
                                            {Object.values(mapData(otpData))}
                                        </div>
                                    </div>
                                    <PrimaryButton
                                        id="bidHistory_submit"
                                        label="Verify code"
                                        type="submit"
                                    />
                                </form>
                            </div>
                        </div>
                    </CustomDialog>
                </>
            )}
        </div>
    )
}

export default Login
